import { Flame, TreePine, Hammer, Beef, Bandage, Shield } from "lucide-react";

export const PERKS = [
  {
    id: "auto-fuel",
    icon: Flame,
    title: "Auto-fuel Fire",
    desc: "Your campfire never dies. Stay warm through every blood-moon night.",
    big: true,
  },
  {
    id: "infinite-wood",
    icon: TreePine,
    title: "Infinite Wood",
    desc: "Build, repair, burn. Forever.",
  },
  {
    id: "infinite-metal",
    icon: Hammer,
    title: "Infinite Metal",
    desc: "Craft the best tools without grinding.",
  },
  {
    id: "infinite-food",
    icon: Beef,
    title: "Infinite Food",
    desc: "Never go hungry, never lose stamina.",
  },
  {
    id: "infinite-bandages",
    icon: Bandage,
    title: "Infinite Bandages",
    desc: "Heal up instantly, as many times as you need.",
  },
  {
    id: "free-protection",
    icon: Shield,
    title: "Free Protection",
    desc: "Stay safe from whatever lurks in the trees.",
  },
];

export const PERK_PRICE = 5;
export const BUNDLE_PRICE = 20;

export function computeTotal(selectedIds) {
  if (!selectedIds || selectedIds.length === 0) return 0;
  if (selectedIds.length === PERKS.length) return BUNDLE_PRICE;
  return selectedIds.length * PERK_PRICE;
}
